import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from '@usitsdasdesign/dds-ng/button';
import { TooltipModule, TooltipOptions } from '@usitsdasdesign/dds-ng/tooltip';
import { CategoriesService } from '../../../shared/categories/categories.service';
import { ICategory, ICategoryListItem, ICategoryThemeSetting } from '../../../shared/categories/typings';
import { EDevices, ResponsiveService } from '../../../shared/services/responsive.service';
import { takeUntil } from 'rxjs';
import { Destroy } from '../../../core/destroyClass';

@Component({
  selector: 'app-article-navigation',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TooltipModule,
  ],
  templateUrl: './article-navigation.component.html',
  styleUrl: './article-navigation.component.scss'
})
export class ArticleNavigationComponent extends Destroy implements OnChanges {
  @Input() currentArticlePath: string;
  @Input() themeSettings: ICategoryThemeSetting;
  @Input() selectedCategory: ICategory;

  protected EDevices = EDevices;

  activeArticleIndex: number = 0;
  previewArticleData: ICategoryListItem;
  previewTooltip: TooltipOptions = {
    tooltipTheme: 'dark',
    tooltipIsInverse: true,
    tooltipWidth: 263,
    tooltipCustomClass: 'article-preview-tooltip'
  };
  currentDevice: EDevices;

  constructor(
    private categoriesService: CategoriesService,
    private responsiveService: ResponsiveService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.updateActiveArticleIndex();
    this.currentDevice = this.responsiveService.getDevice();
    this.responsiveService.device$
      .pipe(takeUntil(this.destroy$))
      .subscribe((device) => (this.currentDevice = device));

    this.applyThemeSettings();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedCategory'] || changes['currentArticlePath']) {
      this.updateActiveArticleIndex();
    }
    
    if (changes['themeSettings'] && this.themeSettings) {
      this.applyThemeSettings();
    }
  }

  private updateActiveArticleIndex(): void {
    if (this.selectedCategory?.list && this.currentArticlePath) {
      this.activeArticleIndex = this.selectedCategory.list.findIndex(
        (item) => item.codeId == this.currentArticlePath
      );
      if (this.activeArticleIndex < 0) {
        this.activeArticleIndex = 0;
      }
    }
  }

  private applyThemeSettings(): void {
    if (this.themeSettings?.tooltipPreview) {
      const root = document.documentElement;
      root.style.setProperty('--previewBorderColor', this.themeSettings.tooltipPreview.borderColor);
      root.style.setProperty('--previewBoxShadow', this.themeSettings.tooltipPreview.shadowColor);
    }
  }

  goToArticle(subCategory: any): void {
    if (subCategory && this.selectedCategory) {
      const categoryPath = this.selectedCategory.path;
      this.router.navigate([subCategory.id, categoryPath, subCategory.path]);
      this.router.navigate(['codedetails/', subCategory.codeId]);
    }
  }

  setPreviewArticleData(articleIndex: number): void {
    if (this.selectedCategory?.list && articleIndex >= 0 && articleIndex < this.selectedCategory.list.length) {
      this.previewArticleData = this.selectedCategory.list[articleIndex];
    }
  }
}
